import config from '../config';

export function fetchJson({ path }) {
	const url = new URL(path, `${config.api.url}/`);

	return fetch(url, { credentials: 'include' })
		.then((response) => {
			if (!response.ok) {
				return Promise.reject(response);
			}

			return response.json();
		});
}
